import React, { useState, useCallback, useEffect } from "react";
import { ReactComponent as RandomSVG } from "../../../assets/random.svg";
import {
  CardsContainer,
  CardBox,
  BackCard,
  Card,
  RandomBtn,
  CardSuit,
  CardSymbol,
  RotatableCard,
} from "./CardStyled.js";

export default ({
  handleChange,
  color,
  cardSuit,
  cardSymbol,
  rotateBtnDisable,
  // isDisabled,
  handleIsDisabled,
  handleCardChange,
  cardChange,
  // result,
  prevCard,
  audio
}) => {
  const [positive, setPositive] = useState(5);
  const [negative, setNegative] = useState(-5);

  const [changeBtn, setChangeBtn] = useState(false);

  const cardStyle = {
    pos: {
      transform: `translate(50%) rotate(${positive}deg)`,
    },
    neg: {
      transform: `translate(50%) rotate(${negative}deg)`,
    },
  };
  const handleRandomRotate = useCallback(() => {
    let pos = Math.floor(Math.random() * 10) + 1;
    let neg = Math.floor(Math.random() * 10) - 10;
    setPositive(pos);
    setNegative(neg);
  }, []);


  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 550);
    }
  };
  useEffect(() => {
    if (!cardChange) {
      handleRandomRotate();
    }
  }, [cardChange, handleRandomRotate]);
  return (
    <CardsContainer>
      <CardBox>
        <BackCard style={cardStyle.pos} />
        <BackCard style={cardStyle.neg} />
        <Card cardChange={!cardChange}>
          <CardSymbol color={color}>{!cardChange && cardSymbol}</CardSymbol>
          <CardSuit>{!cardChange && cardSuit}</CardSuit>
          {!rotateBtnDisable && (
            <RandomBtn change={changeBtn} disabled={changeBtn}>
              <RandomSVG
                onClick={
                  !changeBtn
                    ? () => {
                        setAnimation(changeBtn, setChangeBtn);
                        handleCardChange(true);
                        handleIsDisabled(true);
                        handleChange();
                        audio();
                      }
                    : null
                }
              />
            </RandomBtn>
          )}
        </Card>
        {prevCard && (
          <RotatableCard cardChange={prevCard}>
            <CardSymbol color={color}>{cardSymbol}</CardSymbol>
            <CardSuit>{cardSuit}</CardSuit>
          </RotatableCard>
        )}
      </CardBox>
    </CardsContainer>
  );
};
